import { Component, OnInit } from '@angular/core';
import { sessionStorageKey } from '../wellbean.constants';

@Component({
  selector: 'app-wellbean-change-password-sent',
  templateUrl: './wellbean-change-password-sent.component.html',
  styleUrls: [
    '../style/global.css',
    './wellbean-change-password-sent.component.css',
  ],
})
export class WellbeanChangePasswordSentComponent implements OnInit {
  email: string;
  constructor() {
    this.email = sessionStorage.getItem(sessionStorageKey.passwordResetEmail);
    if (!this.email) {
      history.back();
    }
  }

  ngOnInit(): void {}
}
